import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/icons';
import { getThemeColors } from '../../lib/theme';
import { AppLink, isNewTabClick } from '../../lib/openLink';

const ICON_BUTTON_STYLE = (t: ReturnType<typeof getThemeColors>): React.CSSProperties => ({
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  width: 22, height: 22, flexShrink: 0,
  border: `1px solid ${t.border}`, borderRadius: 6,
  background: t.inputBg, cursor: 'pointer',
});

/* ─── PbProfileLink — Bearbeiten-Button zur vollen PB-Profilseite ──────────
 *
 * Navigiert direkt zur Familienkonto-Detailseite (wie der Bearbeiten-Button
 * in der Pflegebedürftigen-Liste) statt den Karten-Drawer zu öffnen. Fehlt
 * das Familienkonto (href=null), wird nichts gerendert. */
export function PbProfileLink({ href, dark, onOpen }: { href: string | null; dark: boolean; onOpen: () => void }) {
  const t = getThemeColors(dark);
  const { t: tr } = useTranslation();
  if (!href) return null;
  return (
    <AppLink
      to={href}
      stopPropagation
      title={tr('common.action.edit')}
      aria-label={tr('common.action.edit')}
      onClick={(e) => {
        // Normaler Klick: bisheriges Verhalten (onOpen). Strg/Cmd/Mittelklick:
        // echter Link-Klick des Browsers (neuer Tab).
        if (isNewTabClick(e)) return;
        e.preventDefault();
        onOpen();
      }}
      style={{ ...ICON_BUTTON_STYLE(t), textDecoration: 'none' }}
    >
      <Icon.Edit c={t.muted} />
    </AppLink>
  );
}

/* ─── PbNotesButton — Notizen-Icon, öffnet den Familienkonto-Drawer auf dem
 * Notizen-Tab (wie in der Pflegebedürftigen-Liste). Fehlt das Familienkonto
 * (href=null), wird nichts gerendert. */
export function PbNotesButton({ href, dark, onOpen }: { href: string | null; dark: boolean; onOpen: () => void }) {
  const t = getThemeColors(dark);
  const { t: tr } = useTranslation();
  if (!href) return null;
  return (
    <AppLink
      to={href}
      stopPropagation
      title={tr('pflege.list.action.notes_row')}
      aria-label={tr('pflege.list.action.notes_row')}
      onClick={(e) => {
        // Normaler Klick: bisheriges Verhalten (onOpen). Strg/Cmd/Mittelklick:
        // echter Link-Klick des Browsers (neuer Tab).
        if (isNewTabClick(e)) return;
        e.preventDefault();
        onOpen();
      }}
      style={{ ...ICON_BUTTON_STYLE(t), textDecoration: 'none' }}
    >
      <Icon.File c={t.muted} />
    </AppLink>
  );
}
